import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const ASSET_COMPONENTS_ASSET_COMPONENT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory/asset-components',
        parentName: eInventoryRouteNames.Inventory,
        name: 'Inventory::Menu:AssetComponents',
        layout: eLayoutType.application,
        requiredPolicy: 'Inventory.AssetComponents',
      },
    ]);
  };
}
